import { CodeValue, MultiLangText } from '.';
import { Action } from '../AppAbility';

export interface AccessCenter {
	id: number;
	userId: string;
	user?: UserAccount;
	centerId: number;
}
export interface UserAccount {
	accessCenters?: AccessCenter[];
	centerId: number;
	createdAt: Date;
	updatedAt: Date;
	lastSignInAt: Date;
	email: string;
	id: string;
	jobTitle: string;
	name: string;
	ngoId: number;
	phone: string;
	role?: UserRole;
	status: UserAccountStatusCode;
	userCode: string;
	isSignupUser?: boolean;
}

interface UserDtoBase {
	name: string;
	jobTitle?: string;
	phone?: string;
	ngoId?: number;
	centerId?: number;
	roleId?: string;
	accessCenterIds?: number[];
	privateRole?: Pick<
		UserRoleDto,
		'name' | 'permissionIds' | 'baseRoleId'
	> | null;
}
export type UpdateUserDto = UserDtoBase;

export interface CreateUserDto extends UserDtoBase {
	email: string;
	password?: string;
	isSignupUser?: boolean;
}

export interface BasicInfoDto {
	name: string;
	jobTitle?: string;
	ngoId?: number;
	centerId?: number;
	phone?: string;
}

export interface SettingDto {
	email: string;
	roleId?: string;
	accessCenterIds?: number[];
}

export enum UserAccountStatusCode {
	active = 'active',
	suspended = 'suspended',
}

export interface UserPermission {
	id: string;
	item: UserPermissionItem;
	permission: Action;
	roles?: UserRole[];
	roleTemplates?: UserRoleTemplate[];
}

export interface UserPermissionItemGroup extends CodeValue {
	id: string;
	index: number;
	items?: UserPermissionItem[];
}

export interface UserPermissionItem extends CodeValue {
	id: string;
	index: number;
	group: UserPermissionItemGroup;
	permissions: UserPermission[];
}
export interface UserRole {
	id: string;
	code?: string;
	name: string;
	permissions: UserPermission[];
	isPrivate: boolean;
	baseRoleId?: string;
	users?: UserAccount[];
	ngoId?: number;
}

export interface UserRoleTemplate {
	id: string;
	name: MultiLangText;
	permissions: UserPermission[];
}

export interface UserRoleDto {
	id?: string;
	code?: string;
	name: string;
	permissionIds: string[];
	ngoId: number;
	baseRoleId?: string | null;
}

export const PASSWORD_NEED_UPDATE = 'passwordNeedUpdate';
export const TEMPLATE_ROLE_DUMMY_ID = 'TEMPLATE_ROLE_DUMMY_ID';
